// extracted by mini-css-extract-plugin
module.exports = {"product":"product_product__3U_W5","tabs":"product_tabs__3zkkv"};